function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import is from '@sindresorhus/is';
const SCLinkOnComponent = styled(Link).withConfig({
  componentId: "sc-vaom57-0"
})(["display:block;text-decoration:", ";color:", ";cursor:pointer;&:focus,&:hover{text-decoration:", ";background-color:", ";}&:visited,&:link,&:active{text-decoration:", ";}"], props => props.decoration ? props.decoration : 'none', props => props.color ? props.color : 'inherit', props => props.decoration ? props.decoration : 'none', props => props.enablehover ? props.hovercolor ? props.hovercolor : 'rgba(215,223,230,0.25)' : 'transparent', props => props.decoration ? props.decoration : 'none');
const NOFOLLOW = 'nofollow';
const FOLLOW = 'follow';
const linkRelConfig = {
  player: FOLLOW,
  match: NOFOLLOW,
  team: NOFOLLOW,
  tv: NOFOLLOW,
  photos: NOFOLLOW,
  club: FOLLOW,
  matches: FOLLOW
};
const LinkOnComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _props$to;
  let {
    children,
    ...props
  } = _ref;
  const pathname = is.string(props.to) ? props.to : (_props$to = props.to) === null || _props$to === void 0 ? void 0 : _props$to.pathname;
  const isBlocked = pathname ? pathname.match(/\/(region|league)\/($|(testspiele|relegation|global|uebergangsliga|ohne-liga-teams))/) : null;
  const isInterstitialEnabled = (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith('/photos/')) || (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith('/news/'));
  if (!pathname || isBlocked) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  const pathParams = pathname.split('/');
  pathParams.shift();
  const entity = pathParams[0];
  let relMeta = linkRelConfig[entity] || props.rel || 'follow';
  const hasSeason = pathParams[2] === 'season';
  if (hasSeason) {
    relMeta = 'nofollow';
  }
  return /*#__PURE__*/React.createElement(SCLinkOnComponent, _extends({
    ref: ref,
    rel: relMeta,
    "data-google-interstitial": isInterstitialEnabled
  }, props), children);
});
const FPNavLink = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(NavLink, _extends({
    "data-google-interstitial": "false",
    ref: ref
  }, props), children);
});
const FPLink = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(Link, _extends({
    "data-google-interstitial": "false",
    ref: ref
  }, props), children);
});
const FPHTMLLink = _ref4 => {
  let {
    children,
    ...props
  } = _ref4;
  return /*#__PURE__*/React.createElement("a", _extends({
    "data-google-interstitial": "false"
  }, props, {
    "data-sentry-component": "FPHTMLLink",
    "data-sentry-source-file": "link.tsx"
  }), children);
};
export { LinkOnComponent, FPNavLink, FPLink, FPHTMLLink };